import Vue from 'vue'
import data from '@/data'
// import u from '@/util'
import {
  error
} from '@/store'
import {
  t
} from '@/i18n'

const state = {
  item: {},
  items: [],
  cells: [],
  names: [],
  selected: [],
  subcell: null,

  editing: false,
  dirty: false,
  valid: true,
  rules: {
    required: v => !!v || t('Required'),
    start: v => !v || !state.item.end || v <= state.item.end || t('End > start'),
    end: v => !v || !state.item.start || state.item.start <= v || t('End > start')
  }
}

const getters = {
  region: state => state.item.region,
  validations: state => ({
    cellName: [
      v => !state.names.includes(v) || t('Cell name already exists', v)
    ]
  }),
  isNew: (state, _1, _2, rootGetters) => !rootGetters.hasKey(state.item),
  buttons: (state, getters, rootGetters) => name => {
    switch (name) {
      case 'save':
        return {
          disabled: !state.dirty && rootGetters.canSave,
            show: state.editing
        }
    }
  },
  name: state => state.item && state.item['.key'],
  type: state => state.item && state.item.type,
  parent: state => state.item && state.item.parent,
  desc: state => state.item && state.item.desc,
  reportEmails: state => state.item && state.item.reportEmails,
  archived: state => state.item && state.item.archived,
  selected: state => state.selected.length && state.selected[state.selected.length - 1].name || '',
  cellDesc: state => (cell) => (state.cells[cell] || {}).desc || cell
}

const mutations = {
  cell(state, payload) {
    Object.keys(payload).forEach(k => Vue.set(state.item, k, payload[k]))
  },
  cells(state, payload) {
    state.cells = payload
  },
  edit(state, item) {
    state.oldItem = {
      ...(item || {})
    }
    state.item = {
      ...(item || {})
    }
    state.editing = true
  },
  dirty(state, payload) {
    state.dirty = payload
  },
  names(state, payload) {
    state.names = payload
  },
  subcell(state, subcell) {
    state.subcell = subcell
  },
  selected(state, cells) {
    state.selected = cells
  },
  editing(state, flag) {
    state.editing = flag
    if (flag === false) {
      state.item = {}
      state.dirty = false
    }
  },
  valid(state, flag) {
    state.valid = flag
  },

  name(state, payload) {
    Vue.set(state.item, '.key', payload)
  },
  type(state, payload) {
    Vue.set(state.item, 'type', payload)
  },
  section(state, payload) {
    Vue.set(state.item, 'section', payload)
  },
  desc(state, payload) {
    Vue.set(state.item, 'desc', payload)
  },
  reportEmails(state, payload) {
    Vue.set(state.item, 'reportEmails', payload)
  },
  archived(state, payload) {
    Vue.set(state.item, 'archived', payload)
  }

}

const actions = {
  bind: data.cells.bindCells('items'),
  unbind: data.cells.unbindCells('items'),

  async back(context) {
    if (await actions['pass dirty?'](context)) {
      context.commit('editing', false)
    }
  },
  async cell(context, cell) {
    const value = await data.cells.findOne(cell)
    if (value) {
      value.name = cell
      context.commit('cell', value)
      context.commit('selected', [value])
    }
    return value
  },
  async cells(context, paylod) {
    const cells = await data.cells.findAll()
    Object.keys(cells).forEach(k => {
      cells[k].name = k
    })
    context.commit('cells', cells)
  },
  async names(context) {
    context.commit('names', await data.cells.findAll().then(Object.keys))
  },
  async assignments(context, subcell) {
    context.commit('subcell', subcell)
    return context.dispatch('navigate', {
      path: '/cell'
    }, {
      root: true
    })
  },
  async meetings(context, subcell) {
    context.commit('subcell', subcell)
    return context.dispatch('navigate', {
      path: '/meeting2'
    }, {
      root: true
    })
  },

  async select(context) {
    const cell = context.state.item['.key']
    context.commit('editing', false)
    context.commit('cell', cell, {
      root: true
    })
    context.dispatch('assignment/bind', cell, {
      root: true
    })
    context.dispatch('meeting2/dates', cell, {
      root: true
    })
    context.dispatch('meeting2/bindAssignments', cell, {
      root: true
    })
    context.commit('drawer', true, {
      root: true
    })
  },

  async deselect(context) {
    const cell = context.rootState.auth.user.cell
    context.commit('cell', cell, {
      root: true
    })
    context.dispatch('assignment/bind', cell, {
      root: true
    })
    context.dispatch('meeting2/dates', cell, {
      root: true
    })
    context.dispatch('meeting2/bindAssignments', cell, {
      root: true
    })
  },

  async save(context) {
    const item = context.state.item
    // const valid = await context.dispatch('valid', { module: 'assignment' }, { root: true })
    // if (!valid) return
    try {
      const {
        desc,
        type,
        parent,
        reportEmails,
        archived
      } = item
      const o = {
        desc,
        reportEmails,
        type,
        archived: archived || false
      }
      if (parent) {
        o.parent = parent
      }
      await data.cells.save(item['.key'], o)
      context.commit('editing', false)
      context.commit('snackbar', t('Saved'), {
        root: true
      })
    } catch (e) {
      error(context)(e)
    }
  },

  async beforeRouteLeave(context, {
    to,
    from,
    next
  }) {
    if (await actions['pass dirty?'](context)) {
      next()
    } else {
      next(false)
    }
  },

  'pass dirty?': function (context, payload) {
    return context.dispatch('dirty', {
      dirty: context.state.dirty,
      module: 'assignment',
      caller: actions,
      saver: () => {
        actions.save(context, payload || {})
      }
    }, {
      root: true
    })
  }

  // This is too complicated
  // async fetchReportEmails (context, payload) {
  //   const emails = []
  //   const currentItem = await data.cells.findOne(context.rootGetters.cell)
  //   let cell = currentItem.parent
  //   while (cell) {
  //     const item = await data.cells.findOne(cell)
  //     const assignments = await data.assignments.findByCell(cell)
  //
  //     cell = item.parent
  //   }
  //   return emails
  // }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
